import React        from 'react';
import PropTypes    from 'prop-types';
import Tag          from '../Filter/Tag';
import FilterGroup  from './FilterGroup';
import Translations from '../../utils/Translations';
import './../../../../src/VX/Asset/Less/VX/View/Filter.less';

const SIDE_RIGHT = 'right';
const SIDE_LEFT  = 'left';

class Filter extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            selectedSide: 'left',
        };

        this.contentRef = null;

        this.splitSelection = this.splitSelection.bind(this);
    }


    getHeadline() {
        return <div className='content__filter-headline__wrapper'>
            <div className='content__filter-headline'></div>
            <div className='content__filter-headline'>Filter</div>
            <i className='icon -icon-close-line content__filter-headline__close' onClick={this.props.onClickHideFilter} />
        </div>;
    }

    getActiveFilter() {
        return <div className='content__filter-group content__filter-group--active-group'>
            <div className='content__filter-group__headline-container'>
                <span className='content__filter-group__headline'>{Translations.get('common.filtered-by')}</span>
                <span className='content__filter-group__headline-reset'
                      onClick={() => this.props.resetFilter()}>{Translations.get('ResetFilter')}</span>
            </div>
            <div className={'content__filter-list'}>
                <div className='content__filter-list__container'>
                    {this.props.activeFilter.filter(tag => !tag.hidden).map((tag, idx) => <Tag key={idx}
                                                                                               showClose={true}
                                                                                               tag={tag}
                                                                                               onClickTag={this.props.onClickFilterTag}
                                                                                               isActive={true} />)}
                </div>
            </div>
        </div>;
    }

    splitSelection(side) {
        if (this.state.selectedSide !== side) {
            this.setState({selectedSide: side});
        }
    }

    getFilterGroups() {
        if (this.props.isSplitFilter) {
            const videoTagFilters = this.props.filter.filter(filter => filter.type === 'videoFilter');
            const filters         = this.props.filter.filter(filter => filter.type !== 'videoFilter');

            let activeVideoFilterTags = 0;
            let activeFilterTags      = 0;

            videoTagFilters.forEach(filter => {
                filter.tags.forEach((tag) => {
                    if (tag.isActive && !tag.hidden) {
                        activeVideoFilterTags++;
                    }
                });
            });

            filters.forEach(filter => {
                filter.tags.forEach((tag) => {
                    if (tag.isActive && !tag.hidden) {
                        activeFilterTags++;
                    }
                });
            });

            let modelFilter = filters.map((filter, idx) => <FilterGroup key={idx}
                                                                        filter={filter}
                                                                        onClickFilterTag={this.props.onClickFilterTag}
                                                                        activeFilter={this.props.activeFilter}
                                                                        showFilter={this.props.showFilter}
                                                                        expandFilters={false} />);
            let videoFilter = videoTagFilters.map((filter, idx) => <FilterGroup key={idx}
                                                                                filter={filter}
                                                                                onClickFilterTag={this.props.onClickFilterTag}
                                                                                activeFilter={this.props.activeFilter}
                                                                                showFilter={this.props.showFilter}
                                                                                expandFilters={true}
            />);

            let selectedSide = this.state.selectedSide;
            return (<div className={'content__filter-split'}>
                <div className={'content__filter-split-selection'}>
                    <button className={'content__filter-split-selection-item content__filter-split-selection-left ' + (selectedSide === SIDE_LEFT ? 'selected' : '')}
                         onClick={() => this.splitSelection(SIDE_LEFT)}>{Translations.get('Categories')} {activeVideoFilterTags > 0 &&
                            <div className='filter__selection__icon__badge'>{activeVideoFilterTags}</div>}</button>
                    <button className={'content__filter-split-selection-item content__filter-split-selection-right ' + (selectedSide === SIDE_RIGHT ? 'selected' : '')}
                         onClick={() => this.splitSelection(SIDE_RIGHT)}>{Translations.get('interests')} {activeFilterTags > 0 &&
                            <div className='filter__selection__icon__badge'>{activeFilterTags}</div>}</button>
                </div>

                <div className='content__filter-group__container content__filter-group__container--split'>
                    <div className={'content__filter-split-content content__filter-split-content-left ' + (selectedSide === SIDE_LEFT ? 'selected' : '')}>
                        {videoFilter}
                    </div>
                    <div className={'content__filter-split-content content__filter-split-content-right ' + (selectedSide === SIDE_RIGHT ? 'selected' : '')}>
                        {modelFilter}
                    </div>
                </div>
            </div>);
        } else {
            const filters = this.props.filter.map((filter, idx) => <FilterGroup key={idx}
                                                                                filter={filter}
                                                                                onClickFilterTag={this.props.onClickFilterTag}
                                                                                activeFilter={this.props.activeFilter}
                                                                                showFilter={this.props.showFilter}
                                                                                expandFilters={false} />);
            return (<div className='content__filter-group__container'>
                {filters}
            </div>);
        }
    }

    render() {
        return <div className={'content__filter' + (this.props.showFilter ? " content__filter--show" : '')}>
            <div className={'content__filter-content'  + (!this.props.showFilter ? " content__filter-content--hide" : '')} ref={ref => this.contentRef = ref}>
                <div className='content__filter-content__content'>
                    <div className={"content__filter__header-container"}>
                        {this.props.isMobile && this.getHeadline()}
                        {this.getActiveFilter()}
                    </div>
                    {this.getFilterGroups()}
                </div>
                {this.props.isMobile && <div className='content__filter-button__wrapper' onClick={this.props.onClickHideFilter}>
                    <div className='content__filter-group-button'>
                        <div className='content__filter-group-button__line-1'>{this.props.total} {this.props.headline}</div>
                        <div className='content__filter-group-button__line-2'>{Translations.get('old_frontend.VideoGridFilterApply')}</div>
                    </div>
                </div>}
            </div>
        </div>;
    }
}

Filter.propTypes = {
    filter:            PropTypes.array.isRequired,
    activeFilter:      PropTypes.array.isRequired,
    resetFilter:       PropTypes.func,
    showFilter:        PropTypes.bool,
    isMobile:          PropTypes.bool,
    onClickHideFilter: PropTypes.func,
    onClickFilterTag:  PropTypes.func,
    total:             PropTypes.number,
    headline:          PropTypes.string,
    isSplitFilter:     PropTypes.bool,
};

Filter.defaultProps = {
    isSplitFilter: false,
};

export default Filter;
